import { render, staticRenderFns } from "./system-check.component.vue?vue&type=template&id=1d8e8c5e&"
import script from "./system-check.component.vue?vue&type=script&lang=ts&"
export * from "./system-check.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports